import * as Yup from 'yup';

import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

const freelancerLocalize = createLocale('freelancerAvailabilityLocales');

export default Yup.object().shape({
  end_date: Yup.string().required(globalLocalize('fieldRequiredErrorMessage')),
  start_date: Yup.string()
    .when('end_date', {
      is: (value: unknown) => typeof value === 'string',
      then: Yup.string().test(
        'is-start-less-than-end',
        freelancerLocalize('startDateMustBeLessThanEndDate'),
        (value, ctx) => (value as string) < ctx.parent.end_date,
      ),
    })
    .required(globalLocalize('fieldRequiredErrorMessage')),
});
